import React from "react";

import { IconProps } from "./../types";
import { BaseSVGIcon } from "./base-svg-icon";

export const CheckMark24: React.FC<IconProps> = (props) => {
  const strokeColor = props?.stroke ?? "black";
  return (
    <BaseSVGIcon width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        d="M3 12L9 18L21 6"
        stroke={strokeColor}
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M3 12L9 18L21 6"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </BaseSVGIcon>
  );
};
